import { render, staticRenderFns } from "./SyncReport.vue?vue&type=template&id=d4c81b84&"
import script from "./SyncReport.vue?vue&type=script&lang=js&"
export * from "./SyncReport.vue?vue&type=script&lang=js&"
import style0 from "./SyncReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports